import { nsHistorics } from '@/app/i18n/namespaces';

const HISTORICS_OUTCOME_TYPE = {
    SUCCESS: { name: 'SUCCESS', entity: 'status.outcome.success', namespace: nsHistorics, variant: 'green' },
    FAILURE: { name: 'FAILURE', entity: 'status.outcome.failure', namespace: nsHistorics, variant: 'red' }
};

export default HISTORICS_OUTCOME_TYPE;